import type { FC } from "react";
import { useState } from "react";
import classNames from "classnames";
import styles from "./LoginInfoDrawer.module.scss";
import useTranslation from "next-translate/useTranslation";
import { ImageWithFallback } from "@/components/image/ImageWithFallback";
import { LoginMessageContainer } from "./LoginMessageContainer";

const LoginInfoDrawer: FC = () => {
  const { t } = useTranslation("web-payments");
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return isExpanded ? (
    <>
      {/*grey overlay from top of the page*/}
      <div
        onClick={() => {
          setIsExpanded(false);
        }}
        className={styles.overlay}
      />
      <aside
        tabIndex={0}
        className={classNames(styles.drawer)}
        onClick={handleToggle}
      >
        {/*icon and text to collapse the drawer*/}
        <div className={styles.openClose}>
          <ImageWithFallback
            className={styles.openCloseIcon}
            fallbackImage={null}
            width={14}
            height={14}
            alt={t`CHEVRON_DOWN`}
            src={"https://images.onefootball.com/cw/icons/arrow-down-white.svg"}
            darkModeSrc={
              "https://images.onefootball.com/cw/icons/arrow-down-white.svg"
            }
          />
          <p className={classNames(styles.openCloseText, "title-8-medium")}>
            {t`CLOSE_AREA_LABEL`}
          </p>
        </div>

        {/*benefits title and messages*/}
        <p className={classNames(styles.title, "title-6-bold")}>
          {t`BENEFITS_TITLE`}
        </p>
        <div>
          <LoginMessageContainer
            messageTitle={t`BENEFIT_1`}
            messageContent={t`BENEFIT_1_BODY`}
            messageIconUrl="https://images.onefootball.com/cw/icons/star-shape-magenta.svg"
            messageIconDarkUrl="https://images.onefootball.com/cw/icons/star-shape-magenta-dark.svg"
            messageIconAlt={t`MY_INTEREST_EMPTY_ENTITY_SUBTITLE`}
          />

          <LoginMessageContainer
            messageTitle={t`BENEFIT_2`}
            messageContent={t`BENEFIT_2_BODY`}
            messageIconUrl="https://images.onefootball.com/cw/icons/tv-shape-magenta.svg"
            messageIconDarkUrl="https://images.onefootball.com/cw/icons/tv-shape-magenta-dark.svg"
            messageIconAlt="TV"
          />

          <LoginMessageContainer
            messageTitle={t`BENEFIT_3`}
            messageContent={t`BENEFIT_3_BODY`}
            messageIconUrl="https://images.onefootball.com/cw/icons/card-magenta.svg"
            messageIconDarkUrl="https://images.onefootball.com/cw/icons/card-magenta-dark.svg"
            messageIconAlt={t`CREDIT_CARD_METHOD`}
          />
        </div>
      </aside>
    </>
  ) : (
    <aside tabIndex={0} className={styles.drawer} onClick={handleToggle}>
      {/*icon and text to expand the drawer*/}
      <div className={styles.openClose}>
        <ImageWithFallback
          className={styles.openCloseIcon}
          fallbackImage={null}
          width={14}
          height={14}
          alt={t`CHEVRON_UP`}
          src={"https://images.onefootball.com/cw/icons/arrow-up-white.svg"}
          darkModeSrc={
            "https://images.onefootball.com/cw/icons/arrow-up-white.svg"
          }
        />
        <p className={classNames(styles.openCloseText, "title-8-medium")}>
          {t`LEARN_MORE`}
        </p>
      </div>
      <p className={classNames(styles.title, "title-6-bold")}>
        {t`BENEFITS_TITLE`}
      </p>
    </aside>
  );
};

export { LoginInfoDrawer };
